import type { ReceiptChannel, ReceiptStatus } from '@chukua/common';

export type ReceiptAction = 'clear' | 'bounce' | 'reverse';

export const RECEIPT_ACTION_LABELS: Record<ReceiptAction, string> = { clear: 'Mark cleared', bounce: 'Mark bounced', reverse: 'Reverse' };

const RECEIPT_ACTION_DONE: Record<ReceiptAction, string> = { clear: 'marked cleared', bounce: 'marked bounced', reverse: 'reversed' };

/** The toast after the server confirms: "Receipt QK12 marked cleared". A bank transfer may have no reference to name. */
export function receiptActionDoneMessage(action: ReceiptAction, reference: string | null): string {
  return `Receipt ${reference ? `${reference} ` : ''}${RECEIPT_ACTION_DONE[action]}`;
}

/**
 * The actions worth offering on a receipt. Only hides what cannot apply: the server (`refusalFor` in the API's receipt-status policy) is
 * the authority and answers 409 for a stale state. Kept in step by this file's spec, which spells out every status and channel.
 */
export function availableReceiptActions({ channel, status }: { channel: ReceiptChannel; status: ReceiptStatus }): ReceiptAction[] {
  if (status === 'bounced' || status === 'reversed') return [];
  if (channel !== 'cheque') return ['reverse'];
  return status === 'pending' ? ['clear', 'bounce', 'reverse'] : ['bounce', 'reverse'];
}
